import Price from "@JohnLewisPartnership/jl-design-system/dist/components/price/Price";

type Props = {
  /**
   * A string representing the brand of the product. It can also be null or undefined.
   */
  brand: string | undefined | null;
  /**
   * An object representing the price of the product. It can also be undefined. The price object can have 'was', 'then1', 'then2', and 'now' properties, each of which can be a string or an object with 'from' and 'to' properties.
   */
  price:
    | {
        was?: string | { from: string; to: string };
        then1?: string | { from: string; to: string };
        then2?: string | { from: string; to: string };
        now: string | { from: string; to: string };
      }
    | undefined;
  /**
   * A string representing a prefix to be prepended to the price.
   */
  pricePrefix?: string;
  /**
   * A string representing a suffix to be appended to the price.
   */
  priceSuffix?: string;
};

export const PriceUI = ({ brand, price, pricePrefix, priceSuffix }: Props) => {
  if (!price) {
    return null;
  }

  return (
    <Price
      brand={brand}
      price={price}
      pricePrefix={pricePrefix}
      priceSuffix={priceSuffix}
      usageContext="pdp"
      showPriceReduction={false}
      hasDiorPromosEnabled={true}
    />
  );
};
